import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router v6 preserves scroll position by default; for a single-page app
// that browsers treat as one document, this means clicking a link from the
// footer of one page lands halfway down the next. Reset on every route change.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname]);
  return null;
}
